<template>
<div class="container">
<!--    <header class="bg-primary py-5 mb-3">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-lg-12">
                    <h1 class="display-4 text-white mt-5 mb-2">Hanse-Domizil GmbH</h1>
                    <p class="lead mb-5 text-white-50">Sie möchten zur Miete wohnen? Dann sind Sie bei uns richtig.<br>Wohnungssuche einfach und stressfrei mit der Hanse Domizil GmbH.</p>
                </div>
            </div>
        </div>
    </header>
    -->
    <header class="bg-primary py-5 mb-3">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-lg-12">
                    <h1 class="display-4 text-white mt-5 mb-2">Hanse-Domizil GmbH</h1>
                    <p class="lead mb-5 text-white-50">Ab sofort haben wir eine neue Kontaktadresse:</p><p class="h3"><strong>Hanse-Domizil GmbH</strong><br/>Mecklenburgstraße 34<br/>19053 Schwerin<br/>Telefon: 0385 / 59 23 186<br/>Fax: 0385 / 59 23 188</p>
                </div>
            </div>
        </div>
    </header>
<!--
    <div class="row">
        <div class="col-md-8 mb-3">
            <h2>Wohnen bei der Hanse-Domizil GmbH</h2>
            <hr>
            <p>
                Sie möchten in Flensburg, Rendsburg oder doch lieber in Lübeck zur Miete wohnen?<br><strong>Dann sind Sie bei uns richtig.</strong><br><br> Wir haben schöne, bezahlbare Wohnungen<br>für Singles, Familien, junge Leute und Senioren.<br><br>Neue Wohnkonzepte und ein angenehmes Wohnumfeld,<br> so verbindet die HD individuelles Wohnen mit gemeinschaftlichem Leben.<br>
                <br>Treten Sie ein in Ihr neues Zuhause!</p>
-->

            <!-- <a class="btn btn-primary btn-lg" href="#">Mehr erfahren &raquo;</a> -->
<!--
        </div>
        <div class="col-md-4 mb-5">
            <h2>Kontakt</h2>
            <hr>
            <address>
                <strong>Hanse-Domizil GmbH</strong>
                <br>Mecklenburgstraße 34
                <br>19053 Schwerin
                <br>
            </address>
            <address>
-->
                <!-- <abbr title="Phone">P:</abbr> -->
<!--
                0385 / 59 23 186
                <br>
-->
                <!-- <abbr title="Email">E:</abbr> -->
                <!-- <a href="#" @click="this.$parent.changeToContact">Kontaktformular</a> -->
<!--
            </address>
        </div>
    </div>
-->
    <!-- <img alt="Hanse Domizil GmbH" title="Hanse Domizil GmbH" src="./../assets/images/hansedomizil.svg" style="height: 20vh"> -->
</div>
</template>

<script>
export default {
    track() {
        this.$ga.page({
            page: '/',
            title: 'Startseite',
            location: window.location.href
        })
        this.$ga.screenview('Startseite')
    },
}
</script>

<style>

</style>
